import { ActiveForm } from '@/components/form/ActiveSwitch';
import HeaderContainerForm from '@/components/headerContainer/Form';
import { formatDateTime } from '@/utils';
import history from '@/utils/history';

import { useOfferActive } from '../context';

export default function OfferHeading({ data }) {
  const { active, setActive } = useOfferActive()
  return <>
    <HeaderContainerForm
      title='Offer'
      data={{ ...data, createdAt: formatDateTime(data?.created_at), updatedAt: formatDateTime(data?.updated_at) }}
      onCancel={() => history.goBack()}
      className='border-b-0'
    >
      <ActiveForm active={active} onChangeActive={setActive} />
    </HeaderContainerForm>
  </>
}
